import { AdhocHoldOfCntrRepoImpl } from "domain/repository/AdhocHoldOfContainer/AdhocHoldOfCntrRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { useAdhocHoldOfCntrTracked } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import { AdhocHoldOfCntrVM } from "presentation/viewModel/AdhocHoldOfContainer/AdhocHoldOfCntrVM";
import { useMemo } from "react";

export const useAdhocHoldOfCntrVM = () => {
    const [, setAdhocHoldOfCntrState] = useAdhocHoldOfCntrTracked();
    const adhocHoldOfCntrVM = useMemo(() =>
        AdhocHoldOfCntrVM({
            dispatch: [setAdhocHoldOfCntrState],
            adhocHoldOfCntrRepo: AdhocHoldOfCntrRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            // consortiumRepo: ConsortiumRepoImpl(),
        }), [setAdhocHoldOfCntrState])

    return adhocHoldOfCntrVM
}